import type { BoxProps } from '@chakra-ui/react';
import type {
  CardCarouselProps,
  RichTextResolverProp,
} from '@time-line/components/common';
import { CardCarousel } from '@time-line/components/common';
import type { Link } from '@time-line/components/types';
import type { PartnerPerk } from 'types/cms/blocks/PartnerPerksCarousel';

import { PartnerPerkCard } from './PartnerPerkCard';

type PartnerPerksCarouselProps = Omit<
  CardCarouselProps,
  'children' | 'label' | 'title' | 'cta'
> &
  BoxProps & {
    eyebrow?: string;
    title: string;
    cta: Link;
    perks: PartnerPerk[];
    RichTextResolver?: RichTextResolverProp;
  };

export function PartnerPerksCarousel({
  eyebrow,
  title,
  cta,
  perks,
  RichTextResolver,
  ...props
}: PartnerPerksCarouselProps) {
  return (
    <CardCarousel label={eyebrow} title={title} cta={cta} {...props}>
      {perks.map((perk) => (
        <PartnerPerkCard
          key={perk._key}
          {...perk}
          cta={cta}
          RichTextResolver={RichTextResolver}
        />
      ))}
    </CardCarousel>
  );
}
